import * as React from "react";
import { useEffect, useState } from "react";
import { Container, Alert, Typography, Snackbar,Button, TextField, Box } from "@mui/material";
import { MenuInicial } from "./MenuInicial";
import { useNavigate } from "react-router-dom";
import {API_BASE_URL, PRECIOENVIO, PRECIOENVIOALTA}  from '../services/apiConfig';
import { getServerDateTime, getServerHora, isAuthenticated } from '../services/api.js';

function Dashboard() {

  const navigate = useNavigate();
  const [showDiv, setShowDiv] = useState(true);
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const usuarioid = userData?.usuarioid;
  const username = userData?.username;
  const sucursalid = userData?.sucursalid;
  const perfil = userData?.perfil;
  const sucursalnombre =  userData?.sucursalnombre;
  const token = userData?.token;
  const segundosAMostrar = 2; // Cambia esto al valor deseado
  const [open, setOpen] = useState(false);
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [newEnvioPrice, setNewEnvioPrice] = useState(''); // Nuevo precio del envío
  const [isUpdating, setIsUpdating] = useState(false);
  const [fechahora, setFechaHora] = useState(null);
  const [hora, setHora] = useState(null);


  useEffect(() => {

   /* const autenticado = isAuthenticated("Dashboard");
    if (autenticado===false) {
      navigate("/login");
    }
*/
    const obtenerFechaHoraServidor = async () => {
      try {
        const serverDateTime = await getServerDateTime();
        const hora =  await getServerHora();
        setFechaHora(serverDateTime);
        setHora(hora);

      } catch (error) {
        console.error('Error al obtener la fecha y hora del servidor desde el componente React:', error);
      }
    };

    obtenerFechaHoraServidor();

    fetchEnvioPrice();

    const timeoutId = setTimeout(() => {
      setShowDiv(false);
    }, segundosAMostrar * 1000);

    return () => {
      // Limpia el temporizador si el componente se desmonta antes de que se oculte el div
      clearTimeout(timeoutId);
    };
  }, [navigate]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
 
  const fetchEnvioPrice = async () => {
    try {
      const response = await fetch(API_BASE_URL+PRECIOENVIO);
      if (response.ok) {
        const data = await response.json();
        if (Array.isArray(data) && data.length > 0) {
          const precioEnvio = data[0].precio_envio;
          setNewEnvioPrice(precioEnvio.toString());
        } else {
          console.error('Formato de datos inesperado o array vacío');
        }
      } else {
        console.error('Error al obtener el precio de envío');
      }
    } catch (error) {
      console.error('Error al obtener el precio de envío:', error);
    }
  };

  const handleUpdateEnvio = async () => {
    try {
      setIsUpdating(true); // Marca el inicio de la actualización

      const response = await fetch(API_BASE_URL+PRECIOENVIOALTA, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // Agrega otros encabezados si es necesario
        },
        body: JSON.stringify({
          precio: parseFloat(newEnvioPrice), // Nuevo precio del envío como número
        }),
      });

      // Verifica si la actualización fue exitosa
      if (response.ok) {
        setUpdateSuccess(true); // Actualización exitosa
      } else {
        setUpdateSuccess(false); // Actualización fallida
      }

      setIsUpdating(false); // Marca el fin de la actualización
    } catch (error) {
      console.error('Error al actualizar el precio del envío:', error);
      setUpdateSuccess(false);
      setIsUpdating(false); // Marca el fin de la actualización
    }
  };

 


  return (
    <div>
      <Container>
      <MenuInicial></MenuInicial>
      <p><Typography variant="h9" gutterBottom> Bienvenido, {username}! de la sucursal: {sucursalnombre} con el perfil: {perfil}   con id de usuario {usuarioid}  </Typography></p>
      <p><Typography variant="h9" gutterBottom> Estamos apuntando al ambiente {API_BASE_URL}    </Typography></p>
      <p><Typography variant="h9" gutterBottom> La fecha y hora es: {fechahora}    </Typography></p>
      {Number(perfil) === 1 ? (<p><Typography variant="h9" gutterBottom> La hora es: {hora}    </Typography></p> ) : null}


      {showDiv && (
            <p><Alert severity="success"> te logueaste correctamente {username}! y el perfil es {perfil}</Alert></p>
      )}


     {Number(perfil) === 1 || Number(perfil) ===  2? (
     <Box mt={2} display="flex" alignItems="center">
          <TextField
            label="Nuevo Precio de Envío"
            type="number"
            value={newEnvioPrice}
            onChange={(e) => setNewEnvioPrice(e.target.value)}
          />
          <Button
            variant="contained"
            onClick={handleUpdateEnvio}
            sx={{ marginLeft: '16px' }}
            disabled={isUpdating} 
          >
              {isUpdating ? 'Actualizando...' : 'Actualizar Precio de Envío'}
          </Button>
        </Box>
        ) : null}
      </Container>

      
      <Snackbar  autoHideDuration={6000} onClose={handleClose}>
  <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
    This is a success message!
  </Alert>
</Snackbar>

    </div>
  );
}

export default Dashboard;
